import React from 'react'
import Axios from 'axios';
import _ from '../../misc/i18n';
import { validation as v } from '../../misc/formValidationMethods';
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';

const _i18n = {
    _1: _("Tutaj możesz je odzyskać."),
    _2: _('Opcja przywracania hasła działa tylko dla OPERATORÓW i ADMINISTRATORÓW.'),
    _3: _('Wpisz swój login'),
    _4: _('email'),
    _5: _("Adres email podany podczas rejestracji")
}

class PasswordResetForm2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jumboTitle: '',
            jumboText: _("Ładowanie danych"),
            hideForm: true,
            haslo: '',
            potwierdz_haslo: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        let that = this;
        //load data
        let hash = this.props.match.params.hash;
        Axios.get('/api/login/checkIfTokenIsValid/' + hash)
            .then(response => {
                if (response.data === 'ok') {
                    that.setState({
                        jumboTitle: _('Odzyskiwanie hasła'),
                        jumboText: _("Możesz ustawić nowe hasło"),
                        hideForm: false
                    })
                } else {
                    that.setState({
                        jumboTitle: _('Coś tu nie gra!'),
                        jumboText: _('Sprawdź czy link jest poprawny. Pamiętaj, że hasło może być ustawione w czasie 4 godzin od chwili wygenerowania linka.')
                    })
                }
            })
            .catch(err => console.log(err));
    }
    handleChange(event) {
        let state = {};
        state[event.target.name] = event.target.value;
        this.setState(state);
    }
    handleSubmit(event) {
        let that = this;
        event.preventDefault();
        Axios.post('/api/login/updatePassword', { haslo: this.state.haslo, token: this.props.match.params.hash })
            .then(response => {
                let state = { hideForm: true };
                if (response.data === 1) {
                    state.jumboTitle = _('Udało się!');
                    state.jumboText = <div>{_("Zmieniłeś hasło. Przejdź do strony")} <a href='https://calkulator.drzwi-cal.pl/'>logowania</a> {_('by zacząć pracę z systemem.')}</div>;
                } else {
                    state.jumboTitle = _('Coś tu nie gra!');
                    state.jumboText = _("Nie udało się przywrócić hasła. Pamiętaj, że hasło może być ustawione w czasie 4 godzin od chwili wygenerowania linka.");
                }
                that.setState(state);
            })
    }

    render() {
        const { history } = this.props;
        return <div className="container">
            <div className="jumbotron">
                <h1 className="display-4">{this.state.jumboTitle}</h1>
                <p className="lead">{this.state.jumboText}</p>
                <hr className="my-4" />
                {this.state.hideForm !== true &&
                    <Form ref={c => { this.form = c; this.history = history; }} onSubmit={this.state.isEdited ? this.handleEdit : this.handleSubmit}>
                        <div className="form-row">
                            <div className="col">
                                <div className="form-group">
                                    <label htmlFor="haslo">{_('Hasło')}</label>
                                    <Input maxLength="20" minLength="8" type="password" data-edited={this.state.isEdited} value={this.state.haslo} className="form-control" name="haslo" id="haslo" validations={[v.required, v.isEqual, v.lt, v.gt]} placeholder={_("Wpisz hasło")} onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <label htmlFor="potwierdz_haslo">{_('Potwierdzenie hasła')}</label>
                                    <Input maxLength="20" minLength="8" type="password" value={this.state.potwierdz_haslo} className="form-control" name="potwierdz_haslo" id="potwierdz_haslo" validations={[v.isEqual]} placeholder={_("Potwierdź hasło")} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-6">
                                <div className="form-group">
                                    <button className="btn btn-success btn-lg" type="submit">{_('Dalej')}</button>
                                </div>
                            </div>
                        </div>
                    </Form>
                }
            </div>
        </div>
    }
}

class PasswordResetForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jumboTitle: _('Nie pamiętasz hasła?'),
            jumboText: <div>
                <div>{_i18n._1}</div>
                <div className='text-muted'>{_i18n._2}</div>
            </div>,
            login: '',
            email: ''
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        Axios.post('/api/login/passwordReset', this.state)
            .then(response => {
                let state = {
                    jumboTitle: _("Wiadomość wysłana!"),
                    jumboText: _("Jeżeli nie otrzymałeś od nas instrukcji, sprawdź poprawność wpisywanych danych lub skontaktuj się z nami."),
                    messageClassName: "text-center alert alert-success",
                    hideForm: true
                };
                this.setState(state);
            })
            .catch(err => console.log(err))
    }

    handleChange(event) {
        let state = {};
        state[event.target.name] = event.target.value;
        this.setState(state);
    }

    render() {
        return <div>
            <div className="container">
                <div className="jumbotron">
                    <h1 className="display-4">{this.state.jumboTitle}</h1>
                    <p className="lead">{this.state.jumboText}</p>
                    <hr className="my-4" />

                    {this.state.hideForm !== true &&
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="login">{_i18n._3}</label>
                                        <input type="text" value={this.state.login} className="form-control" name="login" id="login" onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <label htmlFor="email">{_i18n._4}</label>
                                        <input type="text" value={this.state.email} className="form-control" name="email" id="email" placeholder={_i18n._5} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-6">
                                    <div className="form-group">
                                        <button className="btn btn-success btn-lg" type="submit">{_('Dalej')}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    }
                </div>
            </div>
        </div >

    }
}

export { PasswordResetForm, PasswordResetForm2 };